let headlinePattern = /^[#]{1,3} (.*)$/;

export function nestMarkdown(markdown) {
    return markdown.split('\n').map(line => {
        let m = line.match(headlinePattern);
        if (!m) {
            return line;
        }
        return `#${line}`;
    }).join('\n');
}
